import { ShortLang } from './const'

export const dictionary = {
	de: {
		form: {
			prename: 'Vorname',
			name: 'Nachname',
			email: 'Emailadresse',
			address: 'Strasse / Nr.',
			zip: 'PLZ',
			city: 'Ort',
			country: 'Land',
			membershipLegend: 'Mitgliedschaft auswählen',
			memberships: {
				individual: 'Einzelmitgliedschaft',
				family: 'Familienmitgliedschaft',
				bringAFriend: 'Bring-a-friend-Mitgliedschaft',
				corporate: 'Firmenmitgliedschaft'
			},
			perYear: 'Jahr',
			submit: 'ZiKD Mitglied werden',
			error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'
		}
	},
	en: {
		form: {
			prename: 'First name',
			name: 'Last name',
			email: 'Email address',
			address: 'Street / No.',
			zip: 'ZIP code',
			city: 'City',
			country: 'Country',
			membershipLegend: 'Select membership',
			memberships: {
				individual: 'Individual membership',
				family: 'Family membership',
				bringAFriend: 'Bring-a-friend membership',
				corporate: 'Corporate membership'
			},
			perYear: 'Year',
			submit: 'Become a ZiKD member',
			error: 'Something went wrong. Please try again.'
		}
	}
} satisfies Record<ShortLang, unknown>

export type Dictionary = (typeof dictionary)[ShortLang]
